import { inject } from '@angular/core';
import { Router, Routes } from '@angular/router';

const EXPENSES = '/accounting/expenses';

/**
 * Expenses live in accounting-ui now (ZEY-2808), behind the shell's /accounting iframe route.
 * The old /expenses screens are no longer routed, but plenty still links to them — the purchase
 * invoice's Expenses tab, journal "go to parent document", projects-ui's budget tab ("add expense
 * for this project"), bookmarks — so each old URL forwards to its accounting-ui twin.
 *
 * ExpensesModule itself stays loaded (app-routing imports it eagerly): the shell's add-expense and
 * link-expense drawers on the purchase invoice still use its components.
 */
export const EXPENSES_REDIRECT_ROUTES: Routes = [
  { path: '', pathMatch: 'full', redirectTo: EXPENSES },
  {
    path: 'add',
    redirectTo: ({ queryParams }) =>
      inject(Router).createUrlTree([EXPENSES, 'new'], {
        queryParams: queryParams['projectUid'] ? { projectUid: queryParams['projectUid'] } : {},
      }),
  },
  {
    path: 'edit',
    redirectTo: ({ queryParams }) =>
      inject(Router).createUrlTree(queryParams['id'] ? [EXPENSES, queryParams['id'], 'edit'] : [EXPENSES]),
  },
  {
    path: 'view',
    redirectTo: ({ queryParams }) =>
      inject(Router).createUrlTree(queryParams['id'] ? [EXPENSES, queryParams['id']] : [EXPENSES]),
  },
];
